module.exports = __webpack_public_path__ + "img/2025-07-21d_2.7223d034.jpg";